import { render, staticRenderFns } from "./AdminClient.vue?vue&type=template&id=2af260bc&"
import script from "./AdminClient.vue?vue&type=script&lang=js&"
export * from "./AdminClient.vue?vue&type=script&lang=js&"
import style0 from "./AdminClient.vue?vue&type=style&index=0&id=2af260bc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports